import React, { useEffect } from 'react';
import { VantifyContextProvider, useVantifyContext } from 'integrations-vantify-context-providers';
import { VantifyEditor } from './VantifyEditor/VantifyEditor';
import type { VantifySettings } from '../types/VantifyEditorTypes';
import {
  ChannelIntegrationEditorProps,
  Integration,
} from '../types/ChannelIntegrationEditorTypes';
import { convertToUUID } from 'uuid-encoding';

function authorizationHeader(token: any): string {
  if (!token) {
    return '';
  }

  if (token.token && token.jti) {
    return `JWT token="${token.token}", jti="${token.jti}"`;
  }

  return `Bearer ${token}`;
}

export function VantifyEditorWrapper(
  props: ChannelIntegrationEditorProps<VantifySettings, Integration> & {
    children?: React.ReactNode;
  }
) {
  const { children, ...editorProps } = props;
  
  return (
    <VantifyContextProvider>
      <VantifyEditorWithAuthSetup {...editorProps} />
      {children}
    </VantifyContextProvider>
  );
}

function VantifyEditorWithAuthSetup(
  props: ChannelIntegrationEditorProps<VantifySettings, Integration>
) {
  const { setAuth, auth } = useVantifyContext();
  const { channelIntegration, channel, getAuthToken, forCreate } = props;
  const { username, password, apiUrl } = channelIntegration.settings || {};
  useEffect(() => {
    async function setupAuth() {
      if (username && password && getAuthToken) {
        const token = await getAuthToken();

        setAuth({
          channelId: channel._id ? convertToUUID(channel._id) : '',
          username,
          password,
          baseUrl: apiUrl || '',
          token: authorizationHeader(token),
        });
      }
    }

    setupAuth();
  }, [username, password, apiUrl, channel._id, setAuth, getAuthToken]);

  if (!forCreate && !auth) {
    return null;
  }

  return <VantifyEditor {...props} />;
}
